module.exports = __webpack_public_path__ + "img/transparent-square.27c4668f.png";